export default __webpack_public_path__ + "static/media/Rank.5d8b528f.png";